/** Welcome/About overlay. Configuration is resolved universally/per-retailer. */
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { usePartnerBranding } from '../../context/PartnerBrandingContext';
import { useSiteExperience } from '../../context/SiteExperienceContext';
import { hasSeenSplash, markSplashSeen } from '../../utils/splashSeen';
import { SplashCard } from './SplashCard';

export const SplashOverlay: React.FC = () => {
  const location = useLocation();
  const { partner } = usePartnerBranding();
  const { config } = useSiteExperience();
  const splash = config.splash;
  const shouldAutoShow = splash.enabled && location.pathname === '/' && !hasSeenSplash(partner?.id);
  const [visible, setVisible] = useState(shouldAutoShow);
  const [fading, setFading] = useState(false);
  const [manualShow, setManualShow] = useState(false);
  const dismiss = () => {
    if (fading) return;
    setFading(true);
    if (!manualShow) markSplashSeen(partner?.id);
    setTimeout(() => { setVisible(false); setManualShow(false); setFading(false); }, 400);
  };
  useEffect(() => {
    if (!shouldAutoShow || manualShow) return;
    const timer = setTimeout(dismiss, 5000);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    const handler = () => { if (splash.enabled) { setFading(false); setManualShow(true); setVisible(true); } };
    window.addEventListener('show-splash', handler);
    return () => window.removeEventListener('show-splash', handler);
  }, [splash.enabled]);
  if (!visible || !splash.enabled) return null;
  return (
    <div className="splash-overlay" style={{ position:'fixed', inset:0, zIndex:9998, display:'flex', alignItems:'center', justifyContent:'center', backgroundColor:'rgba(0,0,0,.7)', backdropFilter:'blur(8px)', WebkitBackdropFilter:'blur(10px)', cursor:'pointer', opacity:fading?0:1, transition:'opacity .4s ease' }} onClick={dismiss}>
      <SplashCard splash={splash} partnerName={partner?.name} onDismiss={dismiss} />
    </div>
  );
};
export default SplashOverlay;
